import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=2c388c52"
import script from "./DocumentsList.vue?vue&type=script&lang=ts"
export * from "./DocumentsList.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsList.vue?vue&type=style&index=0&id=2c388c52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports